"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ProjectDataLayer;
(function (ProjectDataLayer) {
    ProjectDataLayer["ClickHouse"] = "ch";
    ProjectDataLayer["ElasticSearch"] = "es";
    ProjectDataLayer["Redshift"] = "rs";
})(ProjectDataLayer = exports.ProjectDataLayer || (exports.ProjectDataLayer = {}));
//# sourceMappingURL=project.datalayer.js.map